export default "__VITE_ASSET__Dyv51PB1__"